import { Directive, TemplateRef, ViewContainerRef } from '@angular/core'
import { isNative } from 'app/core/utils'

@Directive({
	selector: '[isNative]',
})
export class IsNativeDirective {
	constructor(
		private templateRef: TemplateRef<HTMLElement>,
		private viewContainer: ViewContainerRef
	) {}

	ngOnInit(): void {
		if (isNative) {
			this.viewContainer.createEmbeddedView(this.templateRef)
		} else {
			this.viewContainer.clear()
		}
	}
}
